export enum CheckboxScheme {
  BLUE = 'blue',
  GREEN = 'green',
}

export enum CheckboxLabelScheme {
  BLUE = 'blue',
  BLACK = 'black',
}